/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import "../components/style.css";
import Axios from "axios";
// import ModalPrintRisk_level from "./ModalPrintRisk_level";
import bg from "../img/bg.png";
import Swal from "sweetalert2";
// import { FaEdit } from "react-icons/fa";
import Spinner from "react-bootstrap/Spinner";
// import jwt from "jsonwebtoken";
import { thai_date, handleResizeDisplay, checkGroupsUser, getlocalStorage, formatdate, showLoading, hideLoading } from '../function/functionALL';

require("moment/locale/th");

function ModalFormRisk_level({
  Budget_year,
  round,
  DateTest,
  Tester,
  round_detail,
  checkstatus,
  onClose, onSave, show, choiced, setChoice, chkEmpty, setChkEmpty
}) {
 

  const handleClose = () => {
    setChoice([]);
    setTxtinput([]);
    setChkEmpty(false);
    onClose();
  };

  const { Token, DataToken_ } = getlocalStorage();
  const role = checkGroupsUser(DataToken_.groups)
  const role_openRole = role?.openRole

  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [blood_pressure_upper, setBlood_pressure_upper] = useState("");
  const [blood_pressure_lower, setBlood_pressure_lower] = useState("");
  const navigate = useNavigate();
  const [questionnair, setquestionnair] = useState([]);
  const [Databody_data, setDatabody_data] = useState([]);
  const [answered_question, setanswered_question] = useState([]);
  const [loading, setloading] = useState(false);
  const [txtinput, setTxtinput] = useState([]);
  let count = 1;
  const { date } = round_detail || {};
  useEffect(() => {
    if (show) {
      getData();
    }
  }, [show]);

  const getData = async () => {
    try {
      setloading(true);
      const res = await Axios.get(
        process.env.REACT_APP_API_TESTRESULT + `${Tester.id}/`,
        {
          headers: {
            Authorization: "Token " + Token,
          },
        }
      );
      const res_data = await Axios.get(process.env.REACT_APP_API_QUES, {
        headers: {
          Authorization: "Token " + Token,
        },
      });
      setDatabody_data(res.data.body_data);
      setanswered_question(res.data.answered_question);
      setquestionnair(res_data.data.results);
      setloading(false);
    } catch (err) {
      if (err.response.status === 401) {
        localStorage.removeItem("Token_");
        localStorage.removeItem("Token");
        navigate(
          "/notfound404"
        );

      }
      console.error(err);
      Swal.fire({
        icon: "error",

      })
    }

  };



  const onValueChange = async (e, id) => {
    setChkEmpty(true);
    setChoice({
      ...choiced,
      [e.target.name]: e.target.value,
      [`choice_selected_id_${id}`]: id,
    });
  };

  const onValueChangetextinput = (e, id) => {
    setChkEmpty(true);
    setTxtinput({
      ...txtinput,
      [e.target.name]: e.target.value,
      [`inputTextinput_${id}`]: id,
    });
  };

  const dataAnsw = answered_question.map((answer) => {
    return {
      ...questionnair.find((ques) => ques.number === answer.question_number),
      choice_selected: answer.choice_selected,
      open_answer: answer.open_answer,
      open_score: answer.open_score,
    };
  });

  // console.log("data: ", Tester)
  // const checkWhitespace = (value) => {
  //   return typeof value === 'string' && value.trim().length === 0;
  // };

  const Updatadata = () => {
    const w = weight || Databody_data.weight;
    const h = height || Databody_data.height;

    const data = {
      answered_question: [
        {
          question_id: choiced.choice_selected_id_3 || questionnair[0].id,
          choice_selected_id: isNaN(parseInt(choiced.inlineRadioOptions_0))
            ? answered_question[0]?.choice_selected === "เคย"
              ? questionnair[0].choices[0].id
              : questionnair[0].choices[1].id
            : parseInt(choiced.inlineRadioOptions_0),
        },
        {
          question_id: choiced.choice_selected_id_4 || questionnair[1].id,
          choice_selected_id: isNaN(parseInt(choiced.inlineRadioOptions_1))
            ? answered_question[1]?.choice_selected === "เคย"
                    ? questionnair[1].choices[0].id
              : questionnair[1].choices[1].id
            : parseInt(choiced.inlineRadioOptions_1),
        },
        {
          question_id: choiced.choice_selected_id_5 || questionnair[2].id,
          choice_selected_id: isNaN(parseInt(choiced.inlineRadioOptions_2))
            ? answered_question[2]?.choice_selected === "เคย"
                    ? questionnair[2].choices[0].id
              : questionnair[2].choices[1].id
            : parseInt(choiced.inlineRadioOptions_2),
        },
        {
          question_id: choiced.choice_selected_id_6 || questionnair[3].id,
          choice_selected_id: isNaN(parseInt(choiced.inlineRadioOptions_3))
            ? answered_question[3]?.choice_selected === "เคย"
                    ? questionnair[3].choices[0].id
              : questionnair[3].choices[1].id
            : parseInt(choiced.inlineRadioOptions_3),
        },
        {
          question_id: choiced.choice_selected_id_7 || questionnair[4].id,
          choice_selected_id: isNaN(parseInt(choiced.inlineRadioOptions_4))
            ? answered_question[4]?.choice_selected === "เคย"
                    ? questionnair[4].choices[0].id
              : questionnair[4].choices[1].id
            : parseInt(choiced.inlineRadioOptions_4),
        },
        {
          question_id: choiced.choice_selected_id_8 || questionnair[5].id,
          choice_selected_id: isNaN(parseInt(choiced.inlineRadioOptions_5))
            ? answered_question[5]?.choice_selected === "เคย"
                    ? questionnair[5].choices[0].id
              : questionnair[5].choices[1].id
            : parseInt(choiced.inlineRadioOptions_5),
        },
        // //////////////////////////////////////////////////////////////////////////////////////////////
        {
          question_id: choiced.choice_selected_id_13 || questionnair[6].id,
          choice_selected_id: isNaN(parseInt(choiced.inlineRadioOptions_6))
            ? answered_question[6]?.choice_selected === "สูบบุหรี่"
                    ? questionnair[6].choices[0].id
              : questionnair[6].choices[1].id
            : parseInt(choiced.inlineRadioOptions_6),
        },
        {
          question_id: choiced.choice_selected_id_14 || questionnair[7].id,
          choice_selected_id: isNaN(parseInt(choiced.inlineRadioOptions_7))
            ? answered_question[7]?.choice_selected === "ดื่ม"
                     ? questionnair[7].choices[0].id
              : questionnair[7].choices[1].id
            : parseInt(choiced.inlineRadioOptions_7),
        },
        {
          question_id: choiced.choice_selected_id_22 || questionnair[8].id,
          choice_selected_id: isNaN(parseInt(choiced.inlineRadioOptions_8))
            ? answered_question[8]?.choice_selected === "เคย"
                    ? questionnair[8].choices[0].id
              : questionnair[8].choices[1].id
            : parseInt(choiced.inlineRadioOptions_8),
        },
        {
          question_id: choiced.choice_selected_id_15 || questionnair[9].id,
          choice_selected_id: isNaN(parseInt(choiced.inlineRadioOptions_9))
            ? answered_question[9]?.choice_selected === "เป็น"
                    ? questionnair[9].choices[0].id
              : questionnair[9].choices[1].id
            : parseInt(choiced.inlineRadioOptions_9),
        },
        {
          question_id: choiced.choice_selected_id_17 || questionnair[10].id,
          choice_selected_id: isNaN(parseInt(choiced.inlineRadioOptions_10))
            ? answered_question[10]?.choice_selected === "เป็น"
                    ? questionnair[10].choices[0].id
              : questionnair[10].choices[1].id
            : parseInt(choiced.inlineRadioOptions_10),
        },
        {
          question_id: choiced.choice_selected_id_16 || questionnair[11].id,
          choice_selected_id: isNaN(parseInt(choiced.inlineRadioOptions_11))
            ? answered_question[11]?.choice_selected === "เป็น"
                    ? questionnair[11].choices[0].id
              : questionnair[11].choices[1].id
            : parseInt(choiced.inlineRadioOptions_11),
        },
        {
          question_id: choiced.choice_selected_id_18 || questionnair[12].id,
          choice_selected_id: isNaN(parseInt(choiced.inlineRadioOptions_12))
            ? answered_question[12]?.choice_selected === "เป็น"
                    ? questionnair[12].choices[0].id
              : questionnair[12].choices[1].id
            : parseInt(choiced.inlineRadioOptions_12),
        },
        {
          question_id: choiced.choice_selected_id_19 || questionnair[13].id,
          choice_selected_id: isNaN(parseInt(choiced.inlineRadioOptions_13))
            ? answered_question[13]?.choice_selected === "เป็น"
                    ? questionnair[13].choices[0].id
              : questionnair[13].choices[1].id
            : parseInt(choiced.inlineRadioOptions_13),
        },
        {
          question_id: choiced.choice_selected_id_20 || questionnair[14].id,
          choice_selected_id: isNaN(parseInt(choiced.inlineRadioOptions_14))
            ? answered_question[14]?.choice_selected === "เป็น"
                    ? questionnair[14].choices[0].id
              : questionnair[14].choices[1].id
            : parseInt(choiced.inlineRadioOptions_14),
        },
        {
          question_id: txtinput.inputTextinput_21 || questionnair[15].id,
          open_answer:
            txtinput.inputText_15 === "" || txtinput.inputText_15 === undefined
              ? "-"
              : txtinput.inputText_15 || answered_question[15]?.open_answer,
          // open_score: isNaN(parseInt(choiced.inlineRadioOptions_6))
          //   ? answered_question[15]?.open_score
          //   : parseInt(choiced.inlineRadioOptions_6),
        },
        {
          question_id: txtinput.inputTextinput_10 || questionnair[16].id,
          open_answer:
            txtinput.inputText_16 === "" || txtinput.inputText_16 === undefined
              ? "-"
              : txtinput.inputText_16 || answered_question[16]?.open_answer,
          open_score: isNaN(parseInt(choiced.inlineRadioOptions_16))
            ? answered_question[16]?.open_score
            : parseInt(choiced.inlineRadioOptions_16),
        },
        {
          question_id: txtinput.inputTextinput_1 || questionnair[17].id,
          open_answer:
            txtinput.inputText_17 === "" || txtinput.inputText_17 === undefined
              ? "-"
              : txtinput.inputText_17 || answered_question[17]?.open_answer,
          open_score: isNaN(parseInt(choiced.inlineRadioOptions_17))
            ? answered_question[17]?.open_score
            : parseInt(choiced.inlineRadioOptions_17),
        },
      ],
    };

    const body_data = {
      bmi: (w / ((h / 100) * (h / 100))).toFixed(2),
      height: height || Databody_data.height,
      weight: weight || Databody_data.weight,
      recorder_id: 0,
      blood_pressure_lower:
        blood_pressure_lower || Databody_data.blood_pressure_lower,
      blood_pressure_upper:
        blood_pressure_upper || Databody_data.blood_pressure_upper,
    };


    // console.log("data: ",data);
    if (h < 150 || h > 220 || w < 40 || w > 150) {
      Swal.fire({
        icon: "error",
        title: "กรุณากรอกน้ำหนักหรือส่วนสูงใหม่",
        text: "ส่วนสูง 150- 220 ซม. และ น้ำหนัก 40-150 กก."
      });
    } else if (answered_question.length > 0) {
      //edit
      // console.log("data: ",data);
      const result = {
        data: data,
        body_data: body_data,
      }
      onSave(result, Tester);
    } else if (
      choiced.length < 0 ||
      !chkEmpty ||
      data?.answered_question[16].open_score === undefined ||
      data?.answered_question[17].open_score === undefined ||
      choiced.inlineRadioOptions_0 === undefined ||
      choiced.inlineRadioOptions_1 === undefined ||
      choiced.inlineRadioOptions_2 === undefined ||
      choiced.inlineRadioOptions_3 === undefined ||
      choiced.inlineRadioOptions_4 === undefined ||
      choiced.inlineRadioOptions_5 === undefined ||
      choiced.inlineRadioOptions_6 === undefined ||
      choiced.inlineRadioOptions_7 === undefined ||
      // choiced.inlineRadioOptions_8 === undefined ||
      choiced.inlineRadioOptions_9 === undefined ||
      choiced.inlineRadioOptions_10 === undefined ||
      choiced.inlineRadioOptions_11 === undefined ||
      choiced.inlineRadioOptions_12 === undefined ||
      choiced.inlineRadioOptions_13 === undefined ||
      choiced.inlineRadioOptions_14 === undefined ||
      choiced.inlineRadioOptions_16 === undefined ||
      choiced.inlineRadioOptions_17 === undefined
    ) {
      Swal.fire({
        icon: "error",
        title: "กรุณากรอกข้อมูลให้ครบถ้วน",
      });
      setChkEmpty(false);
    } else {
      //insert
      // console.log("data: ",data);
      const result = {
        data: data,
        body_data: body_data,
      }
      onSave(result, Tester);
    }
  };

  const dataSet = answered_question == [] ? dataAnsw : questionnair;


  return (
    <>

      <Modal
        show={show}

        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop={true}
        centered
        keyboard={false}
      >
        <Modal.Header style={{ height: "30px" }}>

        </Modal.Header>

        <Modal.Body>
          {loading ? (
            <div className="d-flex row pt-4 pb-2 text-center  " >
              <div style={{ color: "white", backgroundColor: "none" }} disabled >

                <Spinner
                  as="span"
                  animation="dark"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                  style={{ width: "5rem", height: "5rem" }}
                />

                <span className="visually-hidden">Loading...</span>
              </div>{' '}
              <div className="text-center" style={{ fontSize: "25px", color: "#71747D", fontWeight: "600" }}>Loading...</div>
            </div>

          ) : (
            <div className="rounded">
              <div className="pt-2">
                <div className="col-sm-12 col-xs-12">
                  <div className="card-body rounded">
                    <div className="row d-flex ">
                      <div
                        className="col-3 col-xs-12 card-title text-center fs-5 w-100 rounded mb-3"
                        style={{
                          color: "#000000",
                          backgroundImage: `url(${bg})`,
                        }}
                      >
                        <div className="fw-bold" style={{ fontSize: "18px" }}>
                          การประเมินความพร้อมก่อนการทดสอบสมรรถภาพทางกาย
                        </div>
                        <div
                          className="fw-bold mt-1"
                          style={{ fontSize: "16px" }}
                        >
                          ปีงบประมาณ {Budget_year} รอบที่ {round} {"("}
                          {thai_date(DateTest || date, "shortdate")}
                          {")"}
                        </div>
                        <div
                          className="col-3 col-xs-12 card-title w-100"
                          style={{ color: "#000000" }}
                        >
                          <div className="">
                            <div
                              className="mb-1 row justify-content-center "
                              style={{ fontSize: "16px", color: "#000000" }}
                            >
                              <span
                                className="p-0 col-12 col-sm-12 col-md-12 fw-bold"
                                style={{ fontSize: "16px", color: "#000000" }}
                              >
                                ชื่อ - นามสกุล : {Tester?.tester_fullname}
                              </span>
                              <span
                                className="p-0 col-12 col-sm-12  fw-bold"
                                style={{ fontSize: "16px", color: "#000000" }}
                              >
                                {" "}
                                อายุ : {Tester?.tester_age} ปี{" "}
                              </span>
                            </div>
                            <div
                              className="shadow-lg w-75 py-3 mt-3 "
                              style={{
                                margin: "0 0 0 12.5%",
                                borderRadius: "16px",
                                background: "rgb(255,255,255,0.2)",
                              }}
                            >
                              <label
                                className="col-12 col-sm-12 "
                                style={{
                                  fontSize: "16px",
                                  color: "#000000",
                                  fontWeight: "600",
                                }}
                              >
                                กรุณากรอกน้ำหนัก/ส่วนสูง
                              </label>
                              <div
                                className="row justify-content-center align-items-center "
                                style={{ fontSize: "16px", color: "#000000" }}
                              >
                                <div className="col-12 col-sm-12 col-lg-6 d-flex align-items-center  mt-2  justify-content-center">
                                  <span
                                    className="col-4 col-lg-4"
                                    style={{ fontSize: "16px", color: "#000000" }}
                                  >
                                    น้ำหนัก :
                                  </span>

                                  {role_openRole?.RTAFPersonAdmin ? (
                                    <input
                                      className="col-4 col-lg-5 form-control text-center mx-2"
                                      type="number"
                                      id="inputText"
                                      placeholder="กรุณากรอกน้ำหนัก"
                                      style={{ fontSize: "14px", width: "30%" }}
                                      defaultValue={Databody_data.weight}
                                      onChange={(event) => {
                                        setWeight(event.target.value);
                                      }}
                                      disabled
                                    ></input>
                                  ) : (
                                    <input
                                      className="col-4 col-lg-5 form-control text-center mx-2"
                                      type="number"
                                      id="inputText"
                                      placeholder="กรุณากรอกน้ำหนัก"
                                      style={{ fontSize: "14px", width: "30%" }}
                                      defaultValue={Databody_data.weight}
                                      onChange={(event) => {
                                        setWeight(event.target.value);
                                      }}
                                      disabled={checkstatus === 0}></input>
                                  )}
                                  <span
                                    className="col-4 col-lg-3"
                                    style={{ fontSize: "16px", color: "#000000" }}
                                  >
                                    กิโลกรัม
                                  </span>
                                </div>

                                <div className="col-12 col-sm-12 col-lg-6 d-flex align-items-center ms-sm-0 mt-2  justify-content-center">
                                  <span
                                    className="col-4 col-lg-3"
                                    style={{ fontSize: "16px", color: "#000000" }}
                                  >
                                    ส่วนสูง :
                                  </span>

                                  {role_openRole?.RTAFPersonAdmin ? (
                                    <input
                                      className="col-4 col-lg-5 form-control text-center mx-2"
                                      type="number"
                                      id="inputText"
                                      placeholder="กรุณากรอกน้ำหนัก"
                                      style={{ fontSize: "14px", width: "30%" }}
                                      defaultValue={Databody_data.height}
                                      onChange={(event) => {
                                        setHeight(event.target.value);
                                      }}
                                      disabled
                                    ></input>
                                  ) : (
                                    <input
                                      className="col-4 col-lg-5 form-control text-center mx-2"
                                      type="number"
                                      id="inputText"
                                      placeholder="กรุณากรอกน้ำหนัก"
                                      style={{ fontSize: "14px", width: "30%" }}
                                      defaultValue={Databody_data.height}
                                      onChange={(event) => {
                                        setHeight(event.target.value);
                                      }}
                                      disabled={checkstatus === 0}></input>
                                  )}
                                  <span
                                    className="col-4 col-lg-4"
                                    style={{ fontSize: "16px", color: "#000000" }}
                                  >
                                    เซนติเมตร
                                  </span>
                                </div>
                              </div>
                              <div
                                className="mt-2 fw-bold"
                                style={{ fontSize: "14px", color: "#000000" }}
                              >
                                BMI : {Databody_data.bmi} กิโลกรัมต่อเมตร
                                <sup>2</sup>
                              </div>
                            </div>

                            <div
                              className="shadow-lg w-75 mt-2 py-3"
                              style={{
                                margin: "0 0 0 12.5%",
                                borderRadius: "14px",
                                background: "rgb(255,255,255,0.2)",
                              }}
                            >
                              <div>
                                <label
                                  className="col-12 col-sm-12 col-form-label"
                                  style={{
                                    fontSize: "16px",
                                    color: "#000000",
                                    fontWeight: "600",
                                  }}
                                >
                                  กรุณากรอกค่าวัดความดันโลหิต{" "}
                                </label>
                                <label
                                  style={{
                                    fontSize: "16px",
                                    color: "#000000",
                                    fontWeight: "600",
                                  }}
                                >
                                  (ค่าบน/ค่าล่าง)
                                </label>
                                <div
                                  className="row justify-content-center align-items-center pt-sm-2"
                                  style={{ fontSize: "16px", color: "#000000" }}
                                >
                                  <div className="col-4 col-sm-2 col-md-3">
                                    {role_openRole?.RTAFPersonAdmin ? (
                                      <input
                                        type="number"
                                        className="form-control text-center"
                                        id="inputText"
                                        placeholder="กรอกค่าบน"
                                        style={{ fontSize: "14px" }}
                                        defaultValue={
                                          Databody_data.blood_pressure_upper
                                        }
                                        onChange={(event) => {
                                          setBlood_pressure_upper(
                                            event.target.value
                                          );
                                        }}
                                        disabled
                                      ></input>
                                    ) : (
                                      <input
                                        type="number"
                                        className="form-control text-center"
                                        id="inputText"
                                        placeholder="กรอกค่าบน"
                                        style={{ fontSize: "14px" }}
                                        defaultValue={
                                          Databody_data.blood_pressure_upper
                                        }
                                        onChange={(event) => {
                                          setBlood_pressure_upper(
                                            event.target.value
                                          );
                                        }}
                                        disabled={checkstatus === 0}></input>
                                    )}
                                  </div>{" "}
                                  /
                                  <div className="col-4 col-sm-2 col-md-3">
                                    {role_openRole?.RTAFPersonAdmin ? (
                                      <input
                                        type="number"
                                        className="form-control text-center"
                                        id="inputText"
                                        placeholder="กรอกค่าล่าง"
                                        style={{ fontSize: "14px" }}
                                        defaultValue={
                                          Databody_data.blood_pressure_lower
                                        }
                                        onChange={(event) => {
                                          setBlood_pressure_lower(
                                            event.target.value
                                          );
                                        }}
                                        disabled
                                      ></input>
                                    ) : (
                                      <input
                                        type="number"
                                        className="form-control text-center"
                                        id="inputText"
                                        placeholder="กรอกค่าล่าง"
                                        style={{ fontSize: "14px" }}
                                        defaultValue={
                                          Databody_data.blood_pressure_lower
                                        }
                                        onChange={(event) => {
                                          setBlood_pressure_lower(
                                            event.target.value
                                          );
                                        }}
                                        disabled={checkstatus === 0}></input>
                                    )}{" "}
                                  </div>
                                  <div
                                    className="col-sm-1 mt-sm-1 col-md-2"
                                    style={{ fontSize: "16px", color: "#000000" }}
                                  >
                                    มม.ปรอท
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <table
                        className="table table-hover top-selling overflow-auto shadow-sm"
                        style={{ fontSize: "14px" }}
                      >
                        <thead className="text-center">
                          <tr>
                            <th
                              className="py-3"
                              style={{ background: "#C39BD3" }}
                            >
                              ลำดับ
                            </th>
                            <th
                              className="py-3"
                              style={{ background: "#C39BD3" }}
                            >
                              คำถาม
                            </th>
                            <th
                              className="py-3"
                              style={{ background: "#85C1E9" }}
                            >
                              เคย
                            </th>
                            <th
                              className="py-3"
                              style={{ background: "#85C1E9" }}
                            >
                              ไม่เคย
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {dataSet.map((question, i) => (
                            <tr className="raw" key={i}>
                              <td className="align-items-center text-center">
                                {
                                  // count++
                                  question.number > 16
                                    ? question.number - 7
                                    : question.number >= 10 &&
                                      question.number <= 16
                                      ? null
                                      : question.number
                                }
                              </td>
                              <td className="align-items-center">
                                {question.number >= 10 && question.number <= 16
                                  ? null
                                  : question.text}
                                {question.number >= 10 &&
                                  question.number <= 16 ? (
                                  <table className="raw">
                                    <tbody>
                                      {question.number >= 10 &&
                                        question.number <= 16 ? (
                                        <tr key={i}>
                                          <td className="align-items-center text-center">
                                            {"9." + count++}&nbsp;
                                          </td>

                                          <td className="align-items-center">
                                            {question.text}
                                          </td>
                                        </tr>
                                      ) : null}
                                    </tbody>
                                  </table>
                                ) : null}
                                {question.is_open === false ? null : (
                                  <div className="col-12">
                                    {question.number === 16 ? null : (
                                      <div className="col-12">โปรดระบุ</div>
                                    )}

                                    {role_openRole?.RTAFPersonAdmin ? (
                                      <div>
                                        <textarea
                                          type="text"
                                          rows="1"
                                          className="form-control mt-1 col-9"
                                          style={{ fontSize: "14px" }}
                                          id="inputText"
                                          name={`inputText_${i}`}
                                          disabled
                                        ></textarea>
                                        <div></div>{" "}
                                      </div>
                                    ) : (
                                      <div>
                                        <textarea
                                          type="text"
                                          rows="1"
                                          className="form-control mt-1 col-9"
                                          style={{ fontSize: "14px" }}
                                          id="inputText"
                                          name={`inputText_${i}`}
                                          onChange={(e) =>
                                            onValueChangetextinput(e, question.id)
                                          }
                                          defaultValue={dataAnsw[i]?.open_answer}
                                          disabled={checkstatus === 0}
                                        ></textarea>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </td>
                              <td className="align-items-center text-center table-info px-sm-4">
                                {question.number === 7 ? (
                                  <div style={{ fontSize: "12px" }}>
                                    สูบบุหรี่
                                  </div>
                                ) : question.number === 8 ? (
                                  <div style={{ fontSize: "12px" }}>ดื่ม</div>
                                ) : question.number === 17 ||
                                  question.number === 18 ? (
                                  <div>
                                    {/* <div style={{ fontSize: "10px" }}></div> */}
                                    <div style={{ fontSize: "10px" }}>
                                      พร้อมทดสอบ
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {question.number === 9 ? (
                                  <div
                                    className="fw-bold"
                                  // style={{ background: "#85C1E9" }}
                                  >
                                    เป็น
                                  </div>
                                ) : question.number === 16 ? (
                                  ""
                                ) : (
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name={`inlineRadioOptions_${i}`}
                                    id={`inlineRadio1_${i}`}
                                    defaultValue={
                                      question.choices.length === 0
                                        ? 0
                                        : question.choices[0]?.id
                                    }
                                    defaultChecked={
                                      i === 16 || i === 17
                                        ? dataAnsw[i]?.open_score === 0
                                        : dataAnsw[i]?.choice_selected ===
                                        "สูบบุหรี่" ||
                                        dataAnsw[i]?.choice_selected ===
                                        "เคย" ||
                                        dataAnsw[i]?.choice_selected ===
                                        "ดื่ม" ||
                                        dataAnsw[i]?.choice_selected === "เป็น"
                                    }
                                    onChange={(e) =>
                                      onValueChange(e, question.id)
                                    }
                                    disabled={
                                      role_openRole?.RTAFPersonAdmin
                                        ? true
                                        : checkstatus === 0 ? true :
                                          false
                                    }
                                  />
                                )}
                              </td>
                              <td className="align-items-center text-center table-info px-sm-4">
                                {question.number === 7 ? (
                                  <div style={{ fontSize: "12px" }}>
                                    ไม่สูบบุหรี่
                                  </div>
                                ) : question.number === 8 ? (
                                  <div style={{ fontSize: "12px" }}>ไม่ดื่ม</div>
                                ) : question.id === 10 || question.id === 1 ? (
                                  <div>
                                    <div style={{ fontSize: "10px" }}></div>
                                    <div style={{ fontSize: "10px" }}>
                                      ไม่พร้อมทดสอบ
                                    </div>
                                  </div>
                                ) : null}
                                {question.number === 9 ? (
                                  <div
                                    className="fw-bold"
                                  // style={{ background: "#85C1E9" }}
                                  >
                                    ไม่เป็น
                                  </div>
                                ) : question.number === 16 ? (
                                  ""
                                ) : (
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name={`inlineRadioOptions_${i}`}
                                    id={`inlineRadio2_${i}`}
                                    defaultValue={
                                      question.choices.length === 0
                                        ? 1
                                        : question.choices[1]?.id
                                    }
                                    defaultChecked={
                                      i === 16 || i === 17
                                        ? dataAnsw[i]?.open_score === 1
                                        : dataAnsw[i]?.choice_selected ===
                                        "ไม่สูบบุหรี่" ||
                                        dataAnsw[i]?.choice_selected ===
                                        "ไม่เคย" ||
                                        dataAnsw[i]?.choice_selected ===
                                        "ไม่ดื่ม" ||
                                        dataAnsw[i]?.choice_selected ===
                                        "ไม่เป็น"
                                    }
                                    onChange={(e) =>
                                      onValueChange(e, question.id)
                                    }
                                    disabled={
                                      role_openRole?.RTAFPersonAdmin
                                        ? true
                                        : checkstatus === 0 ? true :
                                          false
                                    }
                                  />
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </Modal.Body>
        <Modal.Footer>
          <div className="mx-3">
            <div
              className="fw-bold text-decoration-underline"
              style={{ fontSize: "16px" }}
            >
              {" "}
              หมายเหตุ
            </div>
            <span style={{ fontSize: "14px" }}>
              {" "}
              ถ้าความดันโลหิต ≥ 150/100 มม.ปรอท
              <span className="fw-bold text-decoration-underline"> หรือ </span>
              ดัชนีมวลกาย (BMI) ≥ 30 กิโลกรัมต่อเมตร<sup>2</sup>
              <span className="fw-bold text-decoration-underline"> หรือ </span>
              ตอบคำถามข้อใดข้อหนึ่งว่า
              <span className="fw-bold text-decoration-underline"> เคย </span>
              ให้
              <span className="fw-bold text-decoration-underline">
                {" "}
                งดการวิ่ง
              </span>{" "}
              ทดสอบให้เดินทดสอบแทน และทดสอบโดยการลุก-นั่ง (Sit-up) และดันพื้น
              (Push-up) เท่าที่ทำได้ด้วยความระมัดระวัง
            </span>
          </div>

          <div className="col-md-12 col-12 gap-3 d-flex justify-content-center ">
            {role_openRole?.RTAFPersonAdmin ? (
              <Button
                variant="primary"
                style={{ backgroundColor: "rgb(2, 117, 216,0.80)", border: "none" }}
                onClick={() => {
                  handleClose();
                }}
              >
                ยืนยัน
              </Button>
            ) : (
              <Button
                variant="primary "
                style={{ backgroundColor: "rgb(2, 117, 216,0.80)", border: "none" }}
                onClick={() => {
                  Updatadata();
                }}
              >
                ยืนยัน
              </Button>
            )}

            <Button variant="secondary" onClick={handleClose}>
              ยกเลิก / ย้อนกลับ
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalFormRisk_level;
